import { render, staticRenderFns } from "./udatalists2.vue?vue&type=template&id=57ea6102&scoped=true&"
import script from "./udatalists2.vue?vue&type=script&lang=js&"
export * from "./udatalists2.vue?vue&type=script&lang=js&"
import style0 from "./udatalists2.vue?vue&type=style&index=0&id=57ea6102&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ea6102",
  null
  
)

export default component.exports